import React from "react";
import { Switch, withRouter } from "react-router-dom";
import HomeLayout from "./HomeLayout";
import LoginLayout from "./LoginLayout";
import CMSLayout from "./CMSLayout";
import HomePage from "../module/admin/Comman/HomePage";
import CMSPage from "../module/admin/frontEnd/CMSPage";
import CMSPage2 from "../module/admin/frontEnd/CMSPage2";
import NoPage from "../module/admin/frontEnd/NoPage";


const index = (props) => {
     let { pathname } = props.location;    
    let header = <HomeLayout {...props} />
 if (pathname.includes("admin/login") === true) { 
        header = <LoginLayout {...props} />
    } else if(pathname==='/'){
        header = <LoginLayout {...props} />
    }else if(pathname.includes("/postproperty")){
        header=<HomePage {...props}/>
    }else if(pathname == "/privacy-consent" || pathname == "/privacy-policy" || pathname == "/credit-guide" || pathname == "/electronic-communication-consent" || pathname == "/target-market-determinations"){
        header = <CMSLayout {...props} />
        header=<CMSPage {...props}/>
    }
    else if(pathname == "/creatrextransaction"){
        header = <CMSLayout {...props} />
        header=<CMSPage2 {...props}/>
    }  
    else if (pathname.includes("admin") !== true) { 
        header = <CMSLayout {...props} />
        header=<NoPage {...props}/>
    }
    return <Switch>{header}</Switch>
};
export default withRouter(index);
